import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg10 from "../../assets/img/10.png";
import projectimage8 from "../../assets/img/p8.png";

const PreviousCard8 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Diffusion of innovation in social networks</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage8} />
        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg10} />{" "}
            <p className="text7">Balázs Sziklai </p>
            <br />
            <p className="text8">
              Associate Professor <br /> Corvinus University
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              Rogers (1962) classified adopters of innovation into five
              categories: innovators, early adopters, early majority, late
              majority and laggards. It is well-documented that innovators
              and early adopters play a crucial role in the diffusion of
              innovation. Interestingly, the network diffusion literature
              largely ignores these lessons and focuses on
              optimization-related tasks. In their seminal paper, Kempe,
              Kleinberg and Tardos (2003) define the influence
              maximization problem, where we need to find the most
              influential nodes in the network, whose activation would
              cause the largest impact. They also introduce two network
              diffusion models, linear threshold (LT) and independent
              cascade (IC). Although these two remain the most widely
              applied models of diffusion, they completely ignore adopter
              groups and network assortativity, which have been confirmed
              many times to greatly affect innovation spreading. The aim
              of the project is to investigate network diffusion models
              and possibly improve them. In particular, the students will
              develop alternatives for LT and IC, compare network
              centralities on the new models, and characterize certain
              solutions/models. The first two points entail programming
              and simulation tasks (either in Python or C++), while the
              last one is more theoretical and possibly involves
              mathematical proofs.
              <br />
              <br />
              Recommended literature:
              <ul>
                <li>
                  Rogers EM (1962) Diffusion of innovations, 1st ed.
                  <span className="text9">
                    {" "}
                    Free Press of Glencoe, New York{" "}
                  </span>
                </li>
                <li>
                  Kempe D, Kleinberg J, Tardos E (2003) Maximizing the
                  spread of influence through a social network. In:
                  Proceedings of the 9th ACM SIGKDD international
                  conference on knowledge discovery and data mining, KDD
                  ’03,
                  <span className="text9">
                    {" "}
                    Association for Computing Machinery, New York, NY, USA
                  </span>
                  , pp 137–146
                </li>
                <li>
                  Sziklai BR (2018) How to identify experts in a
                  community? <span className="text9"> Int J Game Theory </span>
                  47:155–173
                </li>
                <li>
                  Sziklai BR and Lengyel B (2023) Finding early adopters
                  of innovation in social networks Social
                </li>
                <li>
                  <span className="text9">Network Analysis and Mining </span>{" "}
                  13:4
                </li>
              </ul>{" "}
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default PreviousCard8;
